<!-- <cdk-virtual-scroll-viewport itemSize="200" class="example-viewport cdk"> -->
  <mat-dialog-content>
    <h2 style="text-align: center"><strong>Historico Combustible</strong></h2>
    <h3 style="text-align: center">
      Código del Equipo:{{ data.code }}
    </h3>
    <h3 style="text-align: center">
      Fecha:{{ data.date }}
    </h3>

    <form [formGroup]="formPutFO" (ngSubmit)="
        formPutFO.valid ? updateHistory(formPutFO.value) : errorMessage()
      ">
      <div class="first-row">
        <div class="row-item">
          <mat-form-field>
            <mat-label>Precio Total</mat-label>
            <input autocomplete="off" type="text" appThousandSeparator matInput formControlName="totalPrice" #precio_total
              oninput="this.value = this.value.slice(0,12)" placeholder="Precio Total" required />
            <mat-hint>{{ precio_total.value.length }}/12</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <mat-label>Número Factura</mat-label>
            <input autocomplete="off" type="text" matInput formControlName="billNumber" required #numero_factura
              oninput="this.value = this.value.slice(0,8)" placeholder="Número Factura" required />
            <mat-hint>{{ numero_factura.value.length }}/64</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <mat-label>Orden Venta</mat-label>
            <input autocomplete="off" type="text" matInput formControlName="salesOrder" #orden_venta
              oninput="this.value = this.value.slice(0,8)" placeholder="Orden Venta" required />
            <mat-hint>{{ orden_venta.value.length }}/64</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="default-row">
        <div class="row-item">
          <mat-form-field>
            <mat-label>Medidor actual (horas/km/ciclos)</mat-label>
            <input autocomplete="off" type="text" appThousandSeparator matInput formControlName="currentOdometer" #odometro_actual
              oninput="this.value = this.value.slice(0,8)" placeholder="Medidor actual (horas/km/ciclos)" required />
            <mat-hint>{{ odometro_actual.value.length}}/8</mat-hint>
            <mat-error>Campo requerido</mat-error>
          </mat-form-field>
        </div>
      </div>

      <div style="
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-top: 30px;
        ">
        <button style="width: 60%" color="primary" class="button-save mat-elevation-z5" type="submit" mat-raised-button>
          Aceptar
        </button>
      </div>
    </form>
  </mat-dialog-content>
<!-- </cdk-virtual-scroll-viewport> -->